import { Component, Inject, Input } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { LookupModel } from "@core/services/api.service";
import { UpdateTrackingFreqAction } from "@ngxs-store/managed-tour-store/managed-tour.actions";
import { LoadFrequencyUpdateAction } from "@ngxs-store/update-type-store/update-type.actions";
import { UpdateTypeState } from "@ngxs-store/update-type-store/update-type.state";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { types } from "util";

@Component({
    selector: "app-update-logic-dialog",
    templateUrl: "./update-logic-dialog.html",
    styleUrls: ["./update-logic-dialog.scss"],
})
export class UpdateLogicDialogComponent  {
    @Select(UpdateTypeState.getFrequencyUpdateTypes)
    frequencyUpdateTypes$: Observable<LookupModel[]>;
    @Input() frequencyUpdateTypes: LookupModel[];
    @Input() id: number;
    @Input() buttonType: string;
    frequencyUpdateType: number;
    @Input() trackingFrequency: string;

    constructor(
        public dialogRef: MatDialogRef<UpdateLogicDialogComponent>,
        public builder: FormBuilder,
        private store: Store,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.store.dispatch(new LoadFrequencyUpdateAction());
        this.id = data.id;
        this.trackingFrequency = data.trackingFrequency;

        this.frequencyUpdateTypes$.subscribe((types) => {
            this.frequencyUpdateTypes = types;
        });
    }


    back(): void {
        this.dialogRef.close('canceled');
    }

    save() {
        this.store.dispatch(
            new UpdateTrackingFreqAction(this.id, this.frequencyUpdateType)
        );
        this.dialogRef.close('saved');
    }
}
